import * as React from 'react';
import LayoutDefault from './components/layouts/Default';
import { SettingsContext } from './contexts/settings';

const App = ({ settings }) => {
	// eslint-disable-next-line no-unused-vars
	const renderLayout = (layout) => {
		const LayoutOutput = LayoutDefault;
		// you can use the layout param to provide multiple layout types.
		// switch (layout) {
		// 	case 'table': {
		// 		LayoutOutput = LayoutTable;
		// 		break;
		// 	}
		// }

		return <LayoutOutput />;
	};

	return (
		<SettingsContext.Provider value={settings}>
			{renderLayout(settings.layout)}
		</SettingsContext.Provider>
	);
};

App.displayName = 'App';

export default App;
